import React, { useEffect, useRef } from 'react'
import { THorseWeight } from '../../shared/types/HorseWeight.type'
import Highcharts, { Chart } from 'highcharts/highstock'
import { Skeleton } from '@mui/material'
import { isEmpty } from 'lodash'
import dayjs from 'dayjs'
import { sortDate } from '../../shared/utils/DateUtils'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { TUser } from '../../shared/types/user.type'
import { t } from 'i18next'

import UTC from 'dayjs/plugin/utc'

dayjs.extend(UTC)

type HorseWeightsChartProps = {
    isLoading: boolean,
    data: THorseWeight[]
}

function HorseWeightsChart({ data, isLoading }: HorseWeightsChartProps) {
    const user = useSelector<RootState>(state => state.user.user) as TUser

    const chartRef = useRef<HTMLDivElement | null>(null)
    const chartInstance = useRef<Chart | null>(null);

    useEffect(() => {
        if (!chartRef.current) return
        chartInstance.current = Highcharts.chart(chartRef.current, {
            chart: {
                type: 'scatter', // Defines the chart type as scatter
                backgroundColor: 'transparent',
            },
            title: {
                text: ''
            },
            credits: {
                enabled: false,
            },
            legend: {
                enabled: false
            },

            xAxis: {
                type: 'datetime',
                title: {
                    text: '',
                },
                crosshair: {
                    width: 1,
                },
                gridLineColor: '#444444',
                lineColor: '#888888',
                tickColor: '#888888',
                labels: {
                    format: '{value:%d/%m/%Y}', // Format for date labels
                    style: {
                        color: '#cccccc', // Light gray labels
                        fontSize: '10px'
                    },
                },
            },
            yAxis: {
                title: {
                    text: '',
                },
                gridLineColor: '#444444',
                lineColor: '#888888',
                tickColor: '#888888',
                labels: {
                    style: {
                        color: '#cccccc', // Light gray labels
                    },
                },
            },
            tooltip: {
                useHTML: true,
                backgroundColor: '#161C24',
                formatter: function () {
                    return `
                    <p style='color:white' >${dayjs.utc(this.x).format('DD/MM/YYYY')} </p> </br>
                    <p style='color:white' >${this.y} ${t(user?.unit_system === 'imperial' ? 'units:lbShort' : 'units:kgShort')}</p>
                    `
                }
            },
            series: [],
        });

    }, [])


    useEffect(() => {

        if (chartInstance.current && !isEmpty(data)) {

            let sortedDataByDate = data.sort((a, b) => sortDate(a.start_date, b.start_date, 'DESC'))

            let series = sortedDataByDate.map(item => ({ x: dayjs.utc(item.start_date).valueOf(), y: user?.unit_system === 'metric' ? item.weight : Math.round(item.weight * 2.2) }))

            while (chartInstance.current.series.length) {
                chartInstance.current.series[0].remove();
            }

            chartInstance.current.addSeries({
                type: 'line',
                name: 'Weights Series',
                data: series, // New data points
                color:"#9b141a"

            });
        }


    }, [data])

    return (
        <div ref={chartRef} style={{ width: '100%', height: '220px', marginTop: 10, zIndex: 0, position: 'relative' }} />
    )
}

export default HorseWeightsChart